<ng-container *transloco="let t">
  <div
    id="application-type-selector"
    class="bg-white flex flex-col items-center w-full"
    [class.p-8]="!isMobile()"
    [class.rounded-3xl]="!isMobile()"
    [class.max-w-[560px]]="!isMobile()"
    [class.gap-6]="!isMobile()"
    [class.pt-4]="isMobile()"
    [class.pb-6]="isMobile()"
    [class.px-4]="isMobile()"
    [class.rounded-t-3xl]="isMobile()"
    [class.gap-4]="isMobile()"
    [class.bottom-sheet]="isMobile()"
  >
    @if (isMobile()) {
      <div id="application-type-drag-handle" class="w-8 h-1 bg-ld-neutral-300 rounded-full mb-2"></div>
    }

    <div id="application-type-header" class="flex flex-col gap-4 items-start w-full" [class.gap-3]="isMobile()">
      <div class="flex items-start justify-between w-full">
        <h2
          id="application-type-title"
          class="flex-1 font-dm font-medium text-ld-neutral-700 m-0"
          [class.text-2xl]="!isMobile()"
          [class.leading-8]="!isMobile()"
          [class.tracking-[0.06px]]="!isMobile()"
          [class.text-center]="!isMobile()"
          [class.text-xl]="isMobile()"
          [class.leading-7]="isMobile()"
          [class.text-left]="isMobile()"
        >
          {{ t('applicationTypeSelectorTitle') }}
        </h2>

        @if (!isMobile()) {
          <button
            id="application-type-close-btn"
            type="button"
            class="shrink-0 p-1 rounded-full hover:bg-ld-neutral-50 cursor-pointer transition-colors"
            (click)="onCancel()"
            aria-label="Close"
          >
            <mat-icon class="text-ld-neutral-700">close</mat-icon>
          </button>
        }
      </div>
      <p
        id="application-type-description"
        class="font-dm font-medium text-ld-neutral-500 m-0"
        [class.text-base]="!isMobile()"
        [class.leading-6]="!isMobile()"
        [class.tracking-[0.16px]]="!isMobile()"
        [class.text-center]="!isMobile()"
        [class.w-full]="!isMobile()"
        [class.text-sm]="isMobile()"
        [class.leading-5]="isMobile()"
        [class.text-left]="isMobile()"
      >
        {{ t('applicationTypeSelectorDescription') }}
      </p>
    </div>

    <button
      id="application-type-buy-home-btn"
      type="button"
      class="flex items-center w-full border border-ld-neutral-400 bg-white cursor-pointer transition-all duration-200 hover:border-ld-primary hover:shadow-card focus:outline-2 focus:outline-ld-primary focus:outline-offset-2"
      [class.gap-4]="!isMobile()"
      [class.p-6]="!isMobile()"
      [class.rounded-3xl]="!isMobile()"
      [class.gap-3]="isMobile()"
      [class.p-4]="isMobile()"
      [class.rounded-2xl]="isMobile()"
      (click)="onSelectBuyAHome()"
      [attr.aria-label]="t('applicationTypeSelectorBuyHomeAriaLabel')"
    >
      <div
        id="application-type-buy-home-icon"
        class="shrink-0 flex items-center justify-center"
        [class.w-14]="!isMobile()"
        [class.h-14]="!isMobile()"
        [class.w-14]="isMobile()"
        [class.h-14]="isMobile()"
      >
        <ld-svg-icon
          [src]="buyAHomeIcon"
          [attr.aria-label]="t('applicationTypeSelectorBuyHomeIconAlt')"
          class="w-full h-full"
        />
      </div>
      <div id="application-type-buy-home-details" class="flex flex-col gap-2 grow min-w-0" [class.gap-1]="isMobile()">
        <span
          class="font-dm font-semibold text-ld-neutral-700 text-left"
          [class.text-xl]="!isMobile()"
          [class.leading-7]="!isMobile()"
          [class.tracking-[0.4px]]="!isMobile()"
          [class.text-base]="isMobile()"
          [class.leading-6]="isMobile()"
        >
          {{ t('applicationTypeSelectorBuyHomeTitle') }}
        </span>
        <span
          class="font-dm font-medium text-ld-neutral-500 text-left"
          [class.text-base]="!isMobile()"
          [class.leading-6]="!isMobile()"
          [class.tracking-[0.16px]]="!isMobile()"
          [class.text-sm]="isMobile()"
          [class.leading-5]="isMobile()"
        >
          {{ t('applicationTypeSelectorBuyHomeDescription') }}
        </span>
      </div>
    </button>

    <button
      id="application-type-get-cash-btn"
      type="button"
      class="flex items-center w-full border border-ld-neutral-200 bg-ld-neutral-50 cursor-not-allowed opacity-60"
      [class.gap-4]="!isMobile()"
      [class.p-6]="!isMobile()"
      [class.rounded-3xl]="!isMobile()"
      [class.gap-3]="isMobile()"
      [class.p-4]="isMobile()"
      [class.rounded-2xl]="isMobile()"
      disabled
      [attr.aria-label]="t('applicationTypeSelectorGetCashAriaLabel')"
    >
      <div
        id="application-type-get-cash-icon"
        class="shrink-0 flex items-center justify-center"
        [class.w-14]="!isMobile()"
        [class.h-14]="!isMobile()"
        [class.w-14]="isMobile()"
        [class.h-14]="isMobile()"
      >
        <ld-svg-icon
          [src]="getCashIcon"
          [attr.aria-label]="t('applicationTypeSelectorGetCashIconAlt')"
          class="w-full h-full"
        />
      </div>
      <div id="application-type-get-cash-details" class="flex flex-col gap-2 grow min-w-0" [class.gap-1]="isMobile()">
        <span
          class="font-dm font-semibold text-ld-neutral-700 text-left"
          [class.text-xl]="!isMobile()"
          [class.leading-7]="!isMobile()"
          [class.tracking-[0.4px]]="!isMobile()"
          [class.text-base]="isMobile()"
          [class.leading-6]="isMobile()"
        >
          {{ t('applicationTypeSelectorGetCashTitle') }}
        </span>
        <span
          class="font-dm font-medium text-ld-neutral-500 text-left"
          [class.text-base]="!isMobile()"
          [class.leading-6]="!isMobile()"
          [class.tracking-[0.16px]]="!isMobile()"
          [class.text-sm]="isMobile()"
          [class.leading-5]="isMobile()"
        >
          {{ t('applicationTypeSelectorGetCashDescription') }}
        </span>
      </div>
    </button>

    <button
      id="application-type-lower-payments-btn"
      type="button"
      class="flex items-center w-full border border-ld-neutral-400 bg-white cursor-pointer transition-all duration-200 hover:border-ld-primary hover:shadow-card focus:outline-2 focus:outline-ld-primary focus:outline-offset-2"
      [class.gap-4]="!isMobile()"
      [class.p-6]="!isMobile()"
      [class.rounded-3xl]="!isMobile()"
      [class.gap-3]="isMobile()"
      [class.p-4]="isMobile()"
      [class.rounded-2xl]="isMobile()"
      (click)="onSelectLowerPayments()"
      [attr.aria-label]="t('applicationTypeSelectorLowerPaymentsAriaLabel')"
    >
      <div
        id="application-type-lower-payments-icon"
        class="shrink-0 flex items-center justify-center"
        [class.w-14]="!isMobile()"
        [class.h-14]="!isMobile()"
        [class.w-14]="isMobile()"
        [class.h-14]="isMobile()"
      >
        <ld-svg-icon
          [src]="lowerPaymentsIcon"
          [attr.aria-label]="t('applicationTypeSelectorLowerPaymentsIconAlt')"
          class="w-full h-full"
        />
      </div>
      <div
        id="application-type-lower-payments-details"
        class="flex flex-col gap-2 grow min-w-0"
        [class.gap-1]="isMobile()"
      >
        <span
          class="font-dm font-semibold text-ld-neutral-700 text-left"
          [class.text-xl]="!isMobile()"
          [class.leading-7]="!isMobile()"
          [class.tracking-[0.4px]]="!isMobile()"
          [class.text-base]="isMobile()"
          [class.leading-6]="isMobile()"
        >
          {{ t('applicationTypeSelectorLowerPaymentsTitle') }}
        </span>
        <span
          class="font-dm font-medium text-ld-neutral-500 text-left"
          [class.text-base]="!isMobile()"
          [class.leading-6]="!isMobile()"
          [class.tracking-[0.16px]]="!isMobile()"
          [class.text-sm]="isMobile()"
          [class.leading-5]="isMobile()"
        >
          {{ t('applicationTypeSelectorLowerPaymentsDescription') }}
        </span>
      </div>
    </button>
  </div>
</ng-container>
